export const TARGET_TYPE_APPLICATION = 'application';
